import "./App.css";
import EthforallLogo from "./assets/ethforall_logo.png";

import PolygonIcon from "./assets/polygon-matic-logo.png";
import MantleIcon from "./assets/Mantle_logo.png";
import FilecoinIcon from "./assets/filecoin-fil-logo.png";
import TheGraphLogo from "./assets/the-graph-grt-logo.png";

function App() {
  return (
    <div className="App">
      <div className="main-container">
        <div className="logo">
          <img src={EthforallLogo} alt="ethforall_logo" />
        </div>
        <div className="links-wrapper">
          <div
            className="links"
            onClick={() =>
              (window.location.href =
                "https://celebrated-capybara-a9dd13.netlify.app")
            }
          >
            <img src={PolygonIcon} />
            Salary Disbursement Polygon Track
          </div>
          <div
            className="links"
            onClick={() =>
              (window.location.href =
                "https://comfy-caramel-e6089a.netlify.app/")
            }
          >
            <img src={MantleIcon} />
            Salary Disbursement Mantle Track
          </div>
          <div
            className="links"
            onClick={() =>
              (window.location.href =
                "https://lively-bublanina-e1b095.netlify.app/")
            }
          >
            <img src={TheGraphLogo} />
            The Graph API for Employee Data
          </div>
          <div
            className="links"
            onClick={() =>
              (window.location.href =
                "https://extraordinary-sunshine-377176.netlify.app/")
            }
          >
            <img src={FilecoinIcon} />
            NFT Ticketing Filecoin Track
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
